import { jsx as b } from "react/jsx-runtime";
import { c as v } from "../../vendor-D9Nsxj9p.js";
import { useState as S, useEffect as h } from "react";
import { injectSpacingClasses as C } from "../../utils/injectSpacingClasses/index.js";
import { loadIcon as I } from "./loadIcon/index.js";
import '../../assets/index5.css';const j = "_6FaHxa_blue", y = "_6FaHxa_cactus", E = "_6FaHxa_gold", L = "_6FaHxa_green", M = "_6FaHxa_icon", N = "_6FaHxa_lg", T = "_6FaHxa_magenta", k = "_6FaHxa_md", q = "_6FaHxa_moon", w = "_6FaHxa_purple", z = "_6FaHxa_red", A = "_6FaHxa_sienna", B = "_6FaHxa_sm", D = "_6FaHxa_teal", G = "_6FaHxa_xl", J = "_6FaHxa_xs", n = {
  blue: j,
  cactus: y,
  gold: E,
  green: L,
  icon: M,
  lg: N,
  magenta: T,
  md: k,
  moon: q,
  purple: w,
  red: z,
  sienna: A,
  sm: B,
  teal: D,
  xl: G,
  xs: J
}, U = ({
  m: e,
  mt: c,
  mr: _,
  mb: r,
  ml: l,
  p: m,
  pt: x,
  pr: g,
  pb: u,
  pl: H,
  icon: t,
  description: a,
  color: s,
  size: i = "md",
  className: F
}) => {
  const [d, p] = S(""), o = {
    [n.icon]: !0,
    [n[i]]: !0,
    ...s ? { [n[s]]: !0 } : void 0
  };
  return C(o, { m: e, mt: c, mr: _, mb: r, ml: l, p: m, pt: x, pr: g, pb: u, pl: H }), h(() => {
    I(t).then((f = "") => p(f));
  }, [t]), /* @__PURE__ */ b(
    "span",
    {
      className: v(o, F),
      role: a ? "img" : "presentation",
      "aria-label": a,
      "aria-hidden": a ? void 0 : "true",
      dangerouslySetInnerHTML: { __html: d }
    }
  );
};
export {
  U as Icon
};
//# sourceMappingURL=index.js.map
